/**
 * Contains the implementation for actioning bluetooth requests based on platform
 */
export abstract class AbstractBluetoothAdapter {
    public abstract pair(config: any): Promise<any>;

    public abstract connect(config: any): Promise<any>;

    public abstract getDeviceInfo(config: any): Promise<any>;

    public abstract pairAndConnect(config: any): Promise<any>;

    public abstract getLastPairedDevice(config: any): Promise<any>;

    public abstract setLastPairedDevice(config: any): Promise<any>;

    public abstract clearLastPairedDevice(config: any): Promise<any>;

    public abstract clearAllLastPairedDevices(config: any): Promise<any>;

    public abstract requestDataSerialComm(config: any): Promise<any>;

    public abstract writeDataSerialComm(config: any): Promise<any>;

    public abstract disconnectSerialComm(config: any): Promise<any>;

    public abstract changeCharsetSerialComm(config: any): Promise<any>;

    public abstract connectBle(config: any): Promise<any>;

    public abstract disconnectBle(config: any): Promise<any>;

    public abstract readCharacteristicBle(config: any): Promise<any>;

    public abstract writeCharacteristicBle(config: any): Promise<any>;

    public abstract getPrinterDPI(config: any): Promise<any>;
}
